import { event } from '@uhg-abyss/web/tools/event';

export const adobeModalCloseTrackEvent = (name) => {
  event('MODAL_CLOSE_EVENT', {
    modal: {
      name: name.toLowerCase().replaceAll('-', ' '),
    },
  });
};
